import { render, staticRenderFns } from "./MultisigInput.vue?vue&type=template&id=7b07e639&"
import script from "./MultisigInput.vue?vue&type=script&lang=ts&"
export * from "./MultisigInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports